import styled from 'styled-components';
import ModalBase from '../ModalBase';
import SquareButton from '../../../button/SquareButton';

type ConfirmModalProps = {
  text: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmModal = ({
  text,
  onClose,
  onConfirm,
}: ConfirmModalProps) => {
  return (
    <ModalBase>
      <Container className='even-shadow'>
        <Content>{text}</Content>
        <ButtonHolder>
          <SquareButton text='확인' colorType='ACTIVE' onClick={onConfirm} />
          <SquareButton text='취소' colorType='DISACTIVE' onClick={onClose} />
        </ButtonHolder>
      </Container>
    </ModalBase>
  );
};

const Container = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 700;
  padding: 20px;
  align-items: center;
  justify-content: space-between;
  min-width: 350px;
  border-radius: 6px;
`;

const Content = styled.div`
  min-height: 60px;
  white-space: pre-line;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.colors.charcoal};
`;

const ButtonHolder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
`;
